export default "__VITE_ASSET__abce896d__"